export const OPTIONS = {
  CREATE_SITE: 'CREATE_SITE',
  CREATE_EMAIL: 'CREATE_EMAIL',
  MARKETING_SUPPORT: 'MARKETING_SUPPORT',
  SUPPORT: 'SUPPORT',
  DOMAIN_PURCHASE: 'DOMAIN_PURCHASE',
  MORE: 'MORE',
  CONFIGURE_DOMAIN: 'CONFIGURE_DOMAIN',
  CHECK_MY_ACCOUNT: 'CHECK_MY_ACCOUNT',
  CREATE_POSTS: 'CREATE_POSTS',
};
